import React from "react";

export default function PillCapturando() {
  return <div className="pill capturando">Capturando</div>;
}
